


























import { Component, Vue, Mixins, Watch } from "vue-property-decorator";
// 组件
import Table from "./components/Table.vue";
// 混入
import Loading from "@/mixins/loading";
import debounce from "@/utils/debounce";

@Component({
  components: {
    Table,
  },
})
export default class AuditWithdraw extends Mixins(Loading) {
  phone: string = "";
  shopName: string = "";
  userName: string = "";
  status: string = "1";

  mounted() {}

  /**
   * 监听
   */
  @Watch("shopName")
  @Watch("phone")
  @Watch("userName")
  searchValue() {
    debounce(() => this.handleSearch());
  }

  /**
   * methods
   */
  handleSelect(key: string) {
    this.status = key;
    setTimeout(() => {
      this.handleSearch();
    }, 0);
  }

  // 搜索
  handleSearch() {
    let table: any = this.$refs.table;
    table.getData();
  }
}
